export default __webpack_public_path__ + "static/media/polgot-screenshot-03.3760fdf5.png";